import { render, staticRenderFns } from "./specialRequestForm.vue?vue&type=template&id=6989ba69&scoped=true&"
import script from "./specialRequestForm.vue?vue&type=script&lang=js&"
export * from "./specialRequestForm.vue?vue&type=script&lang=js&"
import style0 from "./specialRequestForm.vue?vue&type=style&index=0&id=6989ba69&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6989ba69",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6989ba69')) {
      api.createRecord('6989ba69', component.options)
    } else {
      api.reload('6989ba69', component.options)
    }
    module.hot.accept("./specialRequestForm.vue?vue&type=template&id=6989ba69&scoped=true&", function () {
      api.rerender('6989ba69', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/Information/components/partner/tab/specialRequestForm.vue"
export default component.exports